export default __webpack_public_path__ + "static/media/olumide.d3baae4b.jpg";